export const rangeArray = (num: number): number[] =>
  Array.from(Array(num).keys()) // [0, 1, 2, etc]
